export default {
  pdf: 'pdf',
  svg: 'svg',
  png: 'png',
  jpg: 'jpg',
  photos: 'photos',
}